import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import {
  MERCADO_PAGO,
  MERCADO_PAGO_FAIL,
  MERCADO_PAGO_SUCCESS,
  SET_ACTUAL_SELECCIONADOS,
  SET_NRO_AFILIADO,
  SET_TURNOS_SELECCIONADOS_LABO,
} from "../ActionTypes";

export const setTurnosSeleccionadosLabo = (turnos) => (dispatch) => {
  dispatch({ type: SET_TURNOS_SELECCIONADOS_LABO, payload: turnos });
};

export const setActualNuevoLabo = (actual) => (dispatch) => {
  dispatch({ type: SET_ACTUAL_SELECCIONADOS, payload: actual });
};

export const setNumeroAfiliado = (nroAfiliado) => (dispatch) => {
  dispatch({type: SET_NRO_AFILIADO, payload: nroAfiliado}); 
}

export const wsPostValidaOnlineLaboratorio = (dtoTurno) => (nextStep) => {
  axiosAutoCheck().then((respuesta) => {
    respuesta
      .post(`/laboratorio/validarOnline`, dtoTurno)
      .then((resp) => {
        if (nextStep && resp?.data) {
          nextStep(true, resp?.data);
        }
      })
      .catch((err) => {
        if (nextStep) {
          nextStep(false, err);
        }
      });
  });
  

  
};

export const wsGetValidaOnlineTokenLaboratorio =
  (idProtocolo) => (nextStep) => {
    axiosAutoCheck().then((respuesta) => {
      respuesta
        .get(`/laboratorio/VerifaValidarOnLineToken/${idProtocolo}`)
        .then((resp) => {
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          if (nextStep) nextStep(false, { token: true });
        });
    });
  };

export const wsGetMontoLaboratorio = (idProtocolo) => (nextStep) => {
  axiosAutoCheck().then((respuesta) => {
    respuesta
      .get(`/laboratorio/montoPresupuesto/${idProtocolo}`)
      .then((resp) => {
        if (nextStep) nextStep(true, 0);
      })
      .catch((err) => {
        if (nextStep) nextStep(false);
      });
  });
};

export const wsGetMercadoPagoLabo = (idProtocolo, nextStep) => (dispatch) => {
   axiosAutoCheck().then((respuesta) => {
    respuesta
      .get(`/laboratorio/qr/${idProtocolo}`)
      .then((resp) => {
        dispatch({ type: MERCADO_PAGO_SUCCESS, payload: resp.data });
        if (nextStep) nextStep(true);
      })
      .catch((err) => {
        dispatch({ type: MERCADO_PAGO_FAIL, payload: err });
        if (nextStep) nextStep(false);
      });
  });
};



export const wsPostAsignarPresenteLabo = (idProtocolo,sectorTurno) => (nextStep) => {
  axiosAutoCheck().then((respuesta) => {
    respuesta
      .post(`/laboratorio/asignarPresente/${idProtocolo}/${sectorTurno}`)
      .then((resp) => {
        if (nextStep) nextStep(true);
      })
      .catch((err) => {
        if (nextStep) nextStep(false);
      });
  });
}; 



export const wsPutNroAfiliado = (valor) => (nextStep) => {
  axiosAutoCheck().then(respuesta => {
      respuesta 
      .put(`/paciente/nroAfiliado/${valor}`)
      .then(resp => {
        if(nextStep) nextStep(true, resp.data); 
      })
      .catch(err => {
        if(nextStep) nextStep(false,err); 
      })
  }); 
};


